import React from 'react';
import sanitizeHtml from 'sanitize-html';
import { DialogTitle, DialogActions, IconButton, Box } from '@mui/material';
import Typography from '@src/new-components/Typography';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { StyledActionDialog } from './index.style';

const ActionDialog = ({
  fullWidth,
  open,
  width,
  image,
  imageContainerSize = '80px',
  imageSize,
  title,
  styleTitle = {},
  styleDescription = {},
  description,
  actionComponent,
  showIconClose = true,
  isSingleActionButton = true,
  textContent = true,
  contentComponent,
  onClose,
  styleContentWrapper = {},
  widthContent,
  paddingMobile = '24px 40px',
  marginMobile = '32px',
  showBlurBackground,
  disableAutoClose = true,
  ...rest
}) => {
  const handleClose = (event, reason) => {
    if (
      disableAutoClose &&
      (reason === 'backdropClick' || reason === 'escapeKeyDown')
    ) {
      return;
    }
    onClose();
  };

  return (
    <StyledActionDialog
      fullWidth={fullWidth}
      open={open}
      onClose={handleClose}
      width={width}
      widthContent={widthContent}
      imageContainerSize={imageContainerSize}
      paddingMobile={paddingMobile}
      marginMobile={marginMobile}
      showBlurBackground={showBlurBackground}
      {...rest}
    >
      {Boolean(showIconClose) && (
        <DialogTitle classes={{ root: 'dialog-title' }}>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            color="secondary"
            className="close-button"
          >
            <CloseRoundedIcon color="secondary" />
          </IconButton>
        </DialogTitle>
      )}
      <Box className="dialog-wrapper">
        <Box className="image-container">
          <img
            style={{ width: imageSize || '100%', height: imageSize || '100%' }}
            src={image}
            alt="icon"
            className="icon"
          />
        </Box>

        <Box className="content-wrapper" style={styleContentWrapper}>
          {textContent && (
            <>
              <Box className="content-description">
                <Typography
                  className="content-title"
                  variant="body-20-bold"
                  style={styleTitle}
                >
                  {title}
                </Typography>
                {description && (
                  <Typography
                    variant="body-16-regular"
                    style={styleDescription}
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                      __html: sanitizeHtml(description, {
                        allowedTags: sanitizeHtml.defaults.allowedTags,
                        allowedAttributes: {
                          ...sanitizeHtml.defaults.allowedAttributes,
                          '*': ['style'],
                        },
                      }),
                    }}
                  />
                )}
              </Box>
            </>
          )}

          {Boolean(contentComponent) && contentComponent}

          {Boolean(actionComponent) &&
            (isSingleActionButton ? (
              <DialogActions classes={{ root: 'dialog-action-single' }}>
                {actionComponent}
              </DialogActions>
            ) : (
              <DialogActions classes={{ root: 'dialog-action' }}>
                {actionComponent}
              </DialogActions>
            ))}
        </Box>
      </Box>
    </StyledActionDialog>
  );
};

export default ActionDialog;
